<app-page-header breadcrumb="Administration" [doubleArrows]="true" title="Contacts"></app-page-header>
<app-admin-tabs
  active="organisations"
  [contactsCount]="contactsCount"
  [organisationsCount]="organisationsCount"
  (reselect)="onTabReselected($event)"></app-admin-tabs>

@if (view === 'list') {
  <app-organisations-list
    [initialSearchTerm]="listSearchTerm"
    (openOrganisation)="openDetail($event)"
    (organisationCreated)="openNewOrganisation($event)"
    (countChanged)="organisationsCount = $event"
    (searchTermChanged)="listSearchTerm = $event"></app-organisations-list>
} @else {
  <app-organisation-detail
    [partyNumber]="selectedPartyNumber"
    [newOrgParty]="newOrgParty"
    [prefetchedContacts$]="newOrgContacts$"
    (back)="backToList($event)"></app-organisation-detail>
}
